<mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'">
   
  <mdb-carousel-item *ngFor="let info of carousel;">
      <div class="view w-1000 w-100">
        <img class="d-block w-100" [src]="info.photoUrl">
        <div class="mask rgba-black-light waves-light" mdbWavesEffect></div>
      </div>
      <div class="carousel-caption">
        <h3 class="h3-responsive" *ngIf="title_en == true">{{info.title}}</h3>
        <h3 class="h3-responsive" *ngIf="title_ar == true">{{info.title_ar}}</h3>
        <p *ngIf="description_en == true">{{info.description}}</p>
        <p *ngIf="description_ar  == true">{{info.description_ar}}</p>
      </div>
    </mdb-carousel-item>

  </mdb-carousel>